import { JSX, splitProps } from 'solid-js';
import { cx } from '@bz/ui';
import './index.css';

function QuickBetSwitch(props: QuickBetSwitchProps) {
  const [, restProps] = splitProps(props, ['onChange', 'value', 'class']);

  return (
    <div
      {...restProps}
      data-disabled={props.disabled}
      class={cx('quick-bet-switch', props.class)}
      aria-checked={props.value || undefined}
      onClick={props.disabled ? () => {} : () => props.onChange && props.onChange(!props.value)}
    >
      <div class="flex items-center justify-center">{props.handleChildren}</div>
    </div>
  );
}

export default QuickBetSwitch;

interface QuickBetSwitchProps extends Omit<JSX.HTMLAttributes<HTMLDivElement>, 'onChange' | 'className'> {
  value: boolean;
  onChange?(value: boolean): void;
  disabled?: boolean;
  handleChildren?: JSX.Element;
  handleClass?: string;
}
